export const posConfig = {
  baseURL: 'https://server.baiclass.online',
};
